export type TUseCaseFoldCards = {
  icon: string;
  title: string;
  description: string;
  href: string;
};

export const useCaseFoldCards: TUseCaseFoldCards[] = [
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1684216276_icons.svg',
    title: 'Don’t have Form-16?',
    description:
      'We will pre-fill your data from IT Department and help you with filing retuns',
    href: '',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1684216314_icons1.svg',
    title: 'Switched jobs?',
    description:
      'Switched jobs in a financial year? You can upload multiple Form-16s and file returns',
    href: '',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1684216324_icons2.svg',
    title: 'Self Employed?',
    description:
      'You can file your tax returns manually without uploading Form-16. You can also upload Form-26AS',
    href: '',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1684216332_icons3.svg',
    title: 'Have business income?',
    description:
      'You can file returns by adding your trading, speculative and presumptive income ',
    href: '',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1684216475_icons4.svg',
    title: 'Invested in Stocks & Mutual Funds',
    description:
      'Simply Upload your P&L Report and we will auto-fill all your data and help you with filing retruns',
    href: '',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1684216487_icons5.svg',
    title: 'Have pension income?',
    description:
      'Add pension details in the Income Sources Page. Also add any other interest earned, if applicable',
    href: '',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1684216497_icons6.svg',
    title: 'Have Crypto Income?',
    description:
      'Simply Upload your P&L Report and we will compute taxes for you',
    href: '',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1684216507_icons7.svg',
    title: 'Have Foreign Income? ',
    description:
      'Add your foreign income details under income sources and we will help you with filing returns',
    href: '',
  },
];
